import type { LayoutSections } from '@teemill/modules/app';

export const printConfig: LayoutSections = {
  announcement: false,
  header: false,
  sidebar: false,
  content: {
    show: true,
    head: false,
    width: '100%',
  },
  footer: {
    show: false,
  },
  subFooter: { show: true },
  navBar: false,
};
